import React from "react";
import { motion } from "framer-motion";
import "./Services.css";

// Banner image
import finalBanner from "../assets/finalbanner.png";

const Services = () => {
  return (
    <div className="services-page-root">
      {/* ================= HERO ================= */}

<section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
  OUR SERVICES
</motion.h1>

  </div>
</section>




      {/* ================= CONTENT ================= */}
      <div className="service-layout">
        {/* LEFT */}
        <motion.div
          className="service-info"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="company-name">FLOWTECH PUMPS AND MOTORS</span>
          <h2 className="service-heading">Service Excellence</h2>

          <p className="service-para">
           A FLOWTECH PUMPS AND MOTORS well represented by own service Team. We have experienced staff and offer effective services coverage.
          </p>

          <p className="service-para">
            As a FLOWTECH cutomer you can therefore enjoy fast and reliable service wherever you are located - in case of unexpected emergencies or as part of a maintenance contract.
          </p>

          <div className="info-section">
            <span className="info-label">Email</span>
            <p className="info-text">flowtechpumps@hotmail.com</p>
            <p className="info-text">info@flowtechpumps.com</p>

            <span className="info-label">Have Any Question</span>
            <p className="info-text">080-297 61 428</p>

            <span className="info-label">Working Days</span>
            <p className="info-text">Monday – Saturday</p>
          </div>
        </motion.div>

        {/* DIVIDER */}
        <div className="vertical-line"></div>

        {/* RIGHT */}
        <motion.div
          className="address-card-container"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="address-card">
            <h5 className="card-title">Office Address</h5>
            <div className="card-address">
              186/10, Haragadde Village,<br />
              Opp Sri Chennakeshava Layout,<br />
              Jigani Anekal Main Road,<br />
              Bengaluru – 560 105
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Services;
